module.exports = __webpack_public_path__ + "static/media/udemy-01.1de5364c.png";